import __request__ from "routing/request";
export function forParameter() {
  return __request__("POST", "/views/forValue", null, {}, {
    "Accept": ["application/json"]
  });
}
